import React, { useState, useEffect } from "react";
import CommonGrid from "../CommonGrid";
import { SpinnerBlock } from "../../Utils/CustomComponent";
import urls from "../../Utils/urls";
import axios from "../../axios";

// const data = [
//   {
//     role: "Lender Admin",
//     client_account_type: "Lender",
//     client_account: "Scott Hacker(SLS-8501)",
//     client_key: "12345",
//     max_use: "5",
//     valid_till: "3/31/23",
//     created: "2 weeks ago",
//     created_by: "pm.sanil@superiorloanservicing.com",
//     updated: "2 weeks ago",
//     update_by: "pm.sanil@superiorloanservicing.com",
//   },
//   {
//     role: "Lender Admin",
//     client_account_type: "Lender",
//     client_account: "Nexus Series B, LLC(SLS-9866)",
//     client_key: "123456",
//     max_use: "99",
//     valid_till: "3/31/23",
//     created: "2 weeks ago",
//     created_by: "pm.sanil@superiorloanservicing.com",
//     updated: "13 days ago",
//     update_by: "pm.sanil@superiorloanservicing.com",
//   },
//   {
//     role: "Lender Admin",
//     client_account_type: "Lender",
//     client_account: "Homeward Opportunities Fund Trust-BPL1(NEB3)",
//     client_key: "123456",
//     max_use: "99",
//     valid_till: "3/31/23",
//     created: "7 weeks ago",
//     created_by: "pm.sanil@superiorloanservicing.com",
//     updated: "13 days ago",
//     update_by: "pm.sanil@superiorloanservicing.com",
//   },
//   {
//     role: "Lender Admin",
//     client_account_type: "Lender",
//     client_account: "EAI Capital LLC(CAP-100)",
//     client_key: "123",
//     max_use: "5",
//     valid_till: "2/4/23",
//     created: "7 weeks ago",
//     created_by: "pm.sanil@superiorloanservicing.com",
//     updated: "7 weeks ago",
//     update_by: "pm.sanil@superiorloanservicing.com",
//   },
// ];
function formatDate(isoDate) {
  const dateObj = new Date(isoDate);

  const day = dateObj.getDate();
  const month = dateObj.getMonth() + 1;
  const year = dateObj.getFullYear();

  return `${day > 9 ? day : "0" + day}/${month}/${year}`;
}

function AdminPortal() {
  const [adminSettings, setAdminSettings] = useState();
  useEffect(() => {
    axios
      .get(urls.admin.getRoleKeys())
      .then((res) => {
        let data = res?.data?.items || [];
        setAdminSettings(data);
      })
      .catch((error) => console.error(error));
  }, []);

  let gridColumns_AdminSettings = [
    {
      field: "role_name",
      title: "Role",
      //   Cell: ({ value }) => <a href="#">{value}</a>,
    },
    {
      field: "sortname",
      title: "Name",
    },
    {
      field: "account",
      title: "Client Account",
    },
    {
      field: "client_key",
      title: "Client Key",
    },
    {
      field: "max_use",
      title: "Max Use",
    },
    {
      field: "valid_till",
      title: "Valid Till",
      Cell: ({ value }) => formatDate(value),
    },
    // {
    //   field: "created",
    //   title: "Created",
    // },
    // {
    //   field: "created_by",
    //   title: "Created By",
    // },
    // {
    //   field: "updated",
    //   title: "Updated",
    // },
    // {
    //   field: "update_by",
    //   title: "Update By",
    // },
  ];
  return (
    <>
      {adminSettings ? (
        <CommonGrid
          title={"Admin Settings"}
          gridColumns={gridColumns_AdminSettings}
          columnData={adminSettings}
        />
      ) : (
        <SpinnerBlock height="41vh" />
      )}
    </>
  );
}

export default AdminPortal;
